import Top from "../../components/MainPage/Top/Top";

const MainPage = () =>{
    return(
        <>
            <Top/>
        </>
    )
}
export {MainPage};